<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n';
import messages from './locales/messages';
import LocaleChanger from '../LocaleChanger.vue';
import FavoritesIcon from '../FavoritesIcon.vue';
import { useSettingsStore } from '@/stores/settings';
import { storeToRefs } from 'pinia'

const { t, locale, availableLocales, getLocaleMessages, mergeLocaleMessage } = useI18n({
  useScope: 'global',
  messages
})

//let menu_open = ref(false)
const { menuOpen: menu_open } = storeToRefs(useSettingsStore())
</script>
<template>
    <header>
        <nav>
            <Hamburger :active="menu_open" @click="menu_open=!menu_open" />
            
            <router-link :to="{name: locale+'.home'}" class="logo_link">
                <img src="@/assets/logos/logo_kase_FR_Rouge_Desktop.png" class="logo"
                srcset="@/assets/logos/logo_kase_FR_Rouge_Desktop.png, @/assets/logos/logo_kase_FR_Rouge_Desktop@2x.png 2x" alt="Kase France" />
            </router-link>
            <div class="flex" id="panier_resp">
                <LocaleChanger  variant="small" :show_iso="false" />
                <AccountIcon id="" :title="$t('compte')" :show="false" :to="{name: locale+'.account'}" />
                <CartIcon :title="$t('mon_panier')" :to="{name: locale+'.cart'}" :show="false" />
            </div>
            <div class="responsive-menu" :class="{open: menu_open}">
                <SearchBox />
                <div class="icons">
                    <LocaleChanger  variant="small" />
                    <FavoritesIcon :title="$t('favorites')" :to="{name: locale+'.category_favorites'}" />
                    <AccountIcon :title="$t('compte')"  :to="{name: locale+'.account'}" />
                    <CartIcon :title="$t('mon_panier')" :to="{name: locale+'.cart'}" :show="true" />
                </div>
                <Menu />
            </div>
        </nav>
    </header>
</template>
<style lang="scss" scoped>
.flex{
    display: flex;
    align-items: center;
}
header{
    position: relative;
}
.responsive-menu{
    display: flex;
    z-index: 99;
    align-items: center;
    overflow: hidden;
    height: 0;
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    transition: all .5s;
    justify-content: flex-start;
    flex-direction: column;
    background-color: #FAFAFA;
    &.open{
        height: calc(100vh - 50px);
        overflow-y: auto;
    }
    .icons{
        display: flex;
        flex-direction: row;
        padding: 20px;
        border-bottom: 1px solid #B4B4B4;
    }
}
nav{
    position: relative;
    display: flex;
    padding: 0 20px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    max-width: 1024px;
    width: 100%;
    .logo_link{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    img.logo{
        height: 31px;
    }
}
header{
    display: flex;
    position: relative;
    justify-content: center;
    width: 100%;
    height: 50px;
    background-color: #FAFAFA;
}
@media only screen and (min-width: $responsive-point) {
    header{
        height: 138px;
        position: relative;
    }
    #panier_resp{
        display: none;
    }
    nav{
        img.logo{
            height: 76px;
        }
        .logo_link{
            position: relative;
            left: 0;
            transform: none;
        }
    }
    .responsive-menu{
        height: 100%;
        max-height: 100%;
        align-self: flex-start;
        position: unset;
        flex-direction: row;
        flex-wrap: wrap;
        overflow: visible;
        top: auto;
        justify-content: space-between;
        padding-left: 15px;
        .icons{
            border-bottom: none;
            padding: 5px 20px 0 20px;
        }
    }
}
</style>